import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import {environment} from '../../environments/environment';
import {Subject} from 'rxjs/Subject';
import {BehaviorSubject, Observable} from 'rxjs/Rx';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import {MessagingService} from './messaging.service';
import {NavigationEnd, Router} from '@angular/router';
import {UserService} from './user.service';

@Injectable()
export class ApiUserService {
  public contentOrigins;
  public currentUser;

  private _apiUserUrl: string = environment.baseUrl + '/apiusers';
  private _userOrgs: string = environment.baseUrl + '/orgs';

  // live observables
  public newApiUserSubject: Subject<any> = new BehaviorSubject<any>(null);
  public routerSubject: Subject<any> = new BehaviorSubject<any>(null);
  public currentUserObserver;
  public currentRoute;

  constructor(private http: Http,
              private userService: UserService,
              public msgService: MessagingService,
              private router: Router) {

    this.currentUserObserver = this.userService.currentUserSubject.subscribe((result) => {
      if (result !== null) {
        this.currentUser = result;
      } else {
        this.currentUser = this.userService.currentUser;
      }
    })

    // subscribe to URL to set proper URLs to load contracts and submit user API form
    this.routerSubject.next(this.router.url);
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/main/organisations') {
          this.routerSubject.next({aka: 'org', route: event.url});
        } else if (event.url.startsWith('/main/organisations/')) {
          this.routerSubject.next({aka: 'orguser', route: event.url});
        } else if (event.url.startsWith('/orguser')) {
          this.routerSubject.next({aka: 'orguserActivate', route: event.url});
          } else {
          this.routerSubject.next({aka: 'main', route: event.url});
        }
      }
    });

    this.routerSubject
      .subscribe((val) => {
        this.currentRoute = val;
      });

    this.contentOrigins = [
      {
        title: 'LDRS',
        id: 'ldrs'
      },
      {
        title: 'BBC',
        id: 'bbc'
      }];

  }

  buildHeaders(type?: string) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    switch (type) {
      case 'code_token':
        headers.append('Authorization', localStorage.getItem('code_token'));
        break
      default:
        break;
    }
    return headers;
  }

  getContracts(org) {
    let headers = this.buildHeaders('code_token');
    let url = this._userOrgs;
    if (org !== undefined && org !== null) {
      if (this.currentRoute.aka === 'org') {
        url = this._userOrgs + '/' + org.id;
      } else if (this.currentRoute.aka === 'orguser') {
        url = this._userOrgs + '/' + this.currentRoute.route.substr(this.currentRoute.route.lastIndexOf('/') + 1);
      }
    } else if (this.currentRoute.aka === 'orguser') {
      url = this._userOrgs + '/' + this.currentRoute.route.substr(this.currentRoute.route.lastIndexOf('/') + 1);
    }

    // if user
    if (this.userService.currentUser.role === 'user') {
      url += '/' + this.currentUser.organization_id;
    }

    return this.http
      .get(
        url,
        {headers})
      .map(res => res.json().contracts)
      .map((res) => {
        return res;
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });

  }

  createUserApiKey(apiUser): Observable<any> {
    let headers = this.buildHeaders('code_token');
    let url = this._apiUserUrl;

    return this.http
      .post(
        url,
        JSON.stringify(apiUser),
        {headers}
      )
      .map((res: Response) => {
        return res.json();
      })
      .map((res) => {
        this.newApiUserSubject.next(res);
        return res;
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

  ableUser(user, able) {
    const headers = this.buildHeaders('code_token');
    return this.http
      .get(
        this._apiUserUrl + '/' + user.id + '/' + able,
        {headers})
      .map((res: Response) => {
        this.msgService.sendMessage(res);
        return res.json();
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

  updateApiUser(apiUser, id): Observable<any> {
    let headers = this.buildHeaders('code_token');

    let url = this._apiUserUrl + '/' + id;

    return this.http
      .put(
        url,
        JSON.stringify(apiUser),
        {headers}
      )
      .map((res: Response) => {
        this.msgService.sendMessage(res);
        return res.json();
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });

  }

  getApiUsers() {
    let headers = this.buildHeaders('code_token');

    return this.http
      .get(
        this._apiUserUrl,
        {headers})
      .map(res => res.json())
      .map((res) => {
        return res;
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

  deleteApiUser(user) {
    let headers = this.buildHeaders('code_token');

    return this.http
      .delete(
        this._apiUserUrl + '/' + user.id,
        {headers}
      )
      .map((res: Response) => {
        this.msgService.sendMessage(res);
        return res.json();
      })
      .map((res) => {
        return res;
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

  regenerateKey(user) {
    let headers = this.buildHeaders('code_token');

    return this.http
      .get(
        this._apiUserUrl + '/regeneratekey/' + user.id,
        {headers})
      .map((res: Response) => {
        this.msgService.sendMessage(res);
        return res.json();
      })
      .map((res) => {
        return res;
      })
      .catch((error: Response) => {
        this.msgService.sendMessage(error);
        return Observable.throw(error);
      });
  }

  verifyApiKeyUserEmail(key): Observable<Response> {
    const headers = this.buildHeaders();
    return this.http
      .put(
        this._apiUserUrl + '/activate/' + key,
        {headers})
      .map((res: Response) => {
        return res.json();
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/service/api-user.service.ts